import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay, map, shareReplay } from 'rxjs/operators';
import { ConfigurationSettingsService } from '../services/configuration-settings/configuration-settings.service';
import { InitializeUserState } from '../actions/generic/user-state.actions';
import { Store } from '@ngxs/store';
import { StateVersionService } from '../services/state/state-version.service';
import { HttpStatusCodes } from '../models/http/http-status-codes.model';

@Injectable()
export class UserStateResolver  {
  private cache$: Observable<any>;

  constructor(
    private configurationSettingsService: ConfigurationSettingsService,
    private stateVersionService: StateVersionService,
    private store: Store
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    let req = this.configurationSettingsService.initializeUserStateSettings().pipe(
      catchError((error: HttpErrorResponse) => {
        // Never cache a failed request; a signed-out user (401) has no saved settings, so resolve with empty state.
        this.cache$ = null;

        return error?.status === HttpStatusCodes.unauthorized ? of({ items: [] }) : throwError(() => error);
      }),
      map((result: any) => {
        const action = new InitializeUserState(result.items);
        this.store.dispatch(action);
        this.stateVersionService.check();

        return true;
      }),
      delay(250)
    );

    if (!this.cache$) {
      this.cache$ = req.pipe(shareReplay(1));
    }

    return this.cache$;
  }
}
